
import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { UserRole } from '../types';
import { LogoPrimary } from '../components/common/Logo';

const AuthLayout: React.FC = () => {
  const { isAuthenticated, user } = useAuth();

  if (isAuthenticated && user) {
    const dest = user.role === UserRole.ADMIN ? '/admin/dashboard' : '/user/dashboard';
    return <Navigate to={dest} replace />;
  }

  return (
    <div className="min-h-dvh bg-brand-dark flex flex-col items-center justify-center p-8 overflow-hidden relative">
      {/* Dynamic Scanline */}
      <div className="fixed inset-0 pointer-events-none z-[60] overflow-hidden">
        <div className="w-full h-[2px] bg-brand-primary/20 shadow-[0_0_15px_#FFCE1B]"></div>
      </div>

      {/* Cinematic Background Elements */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,rgba(255,206,27,0.08),transparent_70%)]"></div>
      <div className="absolute top-[-30%] left-[-20%] w-[100%] h-[100%] bg-brand-primary/10 blur-[200px] rounded-full"></div>
      <div className="absolute bottom-[-30%] right-[-20%] w-[90%] h-[90%] bg-brand-primary/5 blur-[180px] rounded-full"></div>

      {/* Floating Particle Dots */}
      <div className="absolute inset-0 opacity-20 pointer-events-none">
        <div className="absolute top-1/4 left-1/4 w-1 h-1 bg-brand-primary rounded-full"></div>
        <div className="absolute top-3/4 left-1/3 w-1.5 h-1.5 bg-brand-primary rounded-full"></div>
        <div className="absolute top-1/2 right-1/4 w-1 h-1 bg-brand-primary rounded-full"></div>
      </div>

      {/* Decorative Grid */}
      <div className="absolute inset-0 opacity-[0.05] pointer-events-none" style={{ backgroundImage: 'linear-gradient(#fff 1px, transparent 1px), linear-gradient(90deg, #fff 1px, transparent 1px)', backgroundSize: '60px 60px' }}></div>

      <div className="w-full max-w-lg z-10">
        <div className="flex flex-col items-center mb-16">
          <LogoPrimary className="mb-6 filter drop-shadow-[0_0_40px_rgba(255,206,27,0.4)]" width={300} height={70} />
          <div className="flex items-center gap-4">
            <div className="h-[1px] w-12 bg-brand-primary/40"></div>
            <p className="text-brand-muted text-[10px] uppercase tracking-[0.8em] font-black italic">Security Node Terminal</p>
            <div className="h-[1px] w-12 bg-brand-primary/40"></div>
          </div>
        </div>

        <div className="glass-card p-10 sm:p-14 rounded-[4rem] shadow-[0_0_80px_rgba(0,0,0,0.6)] relative group">
          <div className="absolute inset-0 rounded-[4rem] border border-brand-primary/10 pointer-events-none group-hover:border-brand-primary/30 transition-all duration-700"></div>
          <Outlet />
        </div>

        <div className="mt-16 flex flex-col items-center gap-6 opacity-40">
          <div className="flex gap-2">
            {[1, 2, 3].map(i => <div key={i} className="w-1 h-1 bg-brand-primary rounded-full"></div>)}
          </div>
          <p className="text-center text-brand-muted text-[9px] uppercase tracking-[0.5em] font-black leading-relaxed">
            Encrypted Nexus Link Established<br />
            Node: COIN-TX-ALPHA / v4.2.0
          </p>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
